import { render, staticRenderFns } from "./SecurityDashboard.vue?vue&type=template&id=79581923&"
import script from "./SecurityDashboard.vue?vue&type=script&lang=js&"
export * from "./SecurityDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports